function reapplyDrawerSettingsClasses() {
  const root = document.querySelector('cart-drawer');
  if (!root) return;

  const quantityBold = root.dataset.quantityBold === 'true';
  document.querySelectorAll('.cart-drawer .quantity__input').forEach((input) => {
    input.classList.toggle('quantity__input--bold', quantityBold);
  });

  const totalBold = root.dataset.totalBold === 'true';
  const totalValue = document.querySelector('.cart-drawer .totals__total-value');
  if (totalValue) totalValue.classList.toggle('totals__total-value--bold', totalBold);

  const titleBold = root.dataset.titleBold === 'true';
  document.querySelectorAll('.cart-drawer .cart-item__name').forEach((name) => {
    name.classList.toggle('cart-item__name--bold', titleBold);
  });

  const finalPriceBold = root.dataset.finalPriceBold === 'true';
  const comparePriceBold = root.dataset.comparePriceBold === 'true';
  document.querySelectorAll('.cart-drawer .cart-item__price-wrapper').forEach((wrapper) => {
    wrapper.classList.toggle('cart-item__price-wrapper--final-bold', finalPriceBold);
    wrapper.classList.toggle('cart-item__price-wrapper--compare-bold', comparePriceBold);
  });
}

function getReliableItemCount(itemCount) {
  if (typeof itemCount === 'number' && Number.isFinite(itemCount)) return itemCount;
  const badge = document.querySelector('.cart-drawer__header-badge');
  const parsed = badge ? parseInt(badge.textContent.trim(), 10) : NaN;
  return Number.isFinite(parsed) ? parsed : 0;
}

function updateRewardTierBanner(rawItemCount) {
  const banner = document.querySelector('.cart-drawer__reward-tier-banner');
  if (!banner) return;
  const itemCount = getReliableItemCount(rawItemCount);

  let tiers;
  try {
    tiers = JSON.parse(banner.dataset.tiers || '[]');
  } catch (e) {
    return;
  }
  const completeMessage = banner.dataset.completeMessage || "Congrats, you've unlocked every reward!";
  const messageEl = banner.querySelector('.cart-drawer__reward-tier-message');
  const segments = banner.querySelectorAll('.cart-drawer__reward-tier-segment');
  const dots = banner.querySelectorAll('.cart-drawer__reward-tier-dot');

  let prevThreshold = 0;
  let foundCurrent = false;
  let allComplete = true;
  let currentMessage = '';

  tiers.forEach((tier, i) => {
    let state = 'pending';
    let fill = 0;

    if (itemCount >= tier.threshold) {
      state = 'complete';
      fill = 100;
    } else {
      allComplete = false;
      if (!foundCurrent) {
        state = 'current';
        foundCurrent = true;
        const remaining = tier.threshold - itemCount;
        const remainingText = remaining + (remaining === 1 ? ' item' : ' items');
        currentMessage = tier.message.replace('{REMAINING}', remainingText).replace('{LABEL}', tier.label);
        const span = tier.threshold - prevThreshold;
        const progress = itemCount - prevThreshold;
        fill = span > 0 ? (progress * 100) / span : 100;
      }
    }
    prevThreshold = tier.threshold;

    const segment = segments[i];
    const dot = dots[i];
    if (segment) {
      segment.style.setProperty('--segment-fill', `${fill}%`);
      segment.className = `cart-drawer__reward-tier-segment cart-drawer__reward-tier-segment--${state}`;
    }
    if (dot) {
      dot.className = `cart-drawer__reward-tier-dot cart-drawer__reward-tier-dot--${state}`;
    }
  });

  if (messageEl) messageEl.textContent = allComplete ? completeMessage : currentMessage;
}

function updateFreeShippingProgress(rawItemCount) {
  const container = document.querySelector('.cart-drawer__free-shipping-progress');
  if (!container) return;
  const itemCount = getReliableItemCount(rawItemCount);

  const threshold = parseInt(container.dataset.threshold, 10) || 0;
  const messageBefore = container.dataset.messageBefore || '{REMAINING} away from Free Shipping';
  const messageAfter = container.dataset.messageAfter || 'Your order qualifies for Free Shipping';
  const messageEl = container.querySelector('.cart-drawer__free-shipping-progress-message');
  const fill = container.querySelector('.cart-drawer__free-shipping-progress-fill');
  const icon = container.querySelector('.cart-drawer__free-shipping-progress-icon');

  const qualified = itemCount >= threshold;
  let fillPct = 100;
  let message = messageAfter;

  if (!qualified) {
    const remaining = threshold - itemCount;
    const remainingText = remaining + (remaining === 1 ? ' item' : ' items');
    message = messageBefore.replace('{REMAINING}', remainingText);
    fillPct = threshold > 0 ? (itemCount * 100) / threshold : 100;
  }

  container.classList.toggle('cart-drawer__free-shipping-progress--qualified', qualified);
  if (messageEl) messageEl.textContent = message;
  if (fill) fill.style.setProperty('--progress-fill', `${fillPct}%`);
  if (icon) icon.style.setProperty('--progress-fill', `${fillPct}%`);
}

function patchDrawerDynamicContent(sectionHtml, itemCount) {
  const fresh = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const patchSelectors = [
    '.drawer__cart-items-wrapper',
    '.cart-drawer__subtotal-row',
    '.cart-drawer__discounts-amount',
    '.totals__total-value',
    '.cart-drawer__header-badge',
    '.cart-drawer__header-subtitle',
  ];
  patchSelectors.forEach((selector) => {
    const target = document.querySelector(selector);
    const source = fresh.querySelector(selector);
    if (target && source) target.innerHTML = source.innerHTML;
  });
  document.querySelectorAll('.cart__checkout-button').forEach((button) => {
    button.disabled = itemCount === 0;
  });
  reapplyDrawerSettingsClasses();
  updateRewardTierBanner(itemCount);
  updateFreeShippingProgress(itemCount);

  const itemsWrapper = document.querySelector('.drawer__cart-items-wrapper');
  const hasItemRows = itemsWrapper ? itemsWrapper.querySelectorAll('.cart-item').length > 0 : false;
  return !(itemCount > 0 && !hasItemRows);
}

function patchCartIconBubble(sectionHtml) {
  if (!sectionHtml) return;
  const bubble = document.getElementById('cart-icon-bubble');
  if (!bubble) return;
  const fresh = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const source = fresh.querySelector('.shopify-section');
  if (source) bubble.innerHTML = source.innerHTML;
}

let cartTouchMoveBlocker = null;
let cartTouchStartY = 0;

function rememberTouchStart(event) {
  cartTouchStartY = event.touches[0].clientY;
}

function lockBackgroundTouchScroll(scrollableElement) {
  cartTouchMoveBlocker = (event) => {
    if (scrollableElement && scrollableElement.contains(event.target)) {
      const draggingDown = event.touches[0].clientY > cartTouchStartY;
      const atTop = scrollableElement.scrollTop <= 0;
      const atBottom =
        scrollableElement.scrollTop + scrollableElement.clientHeight >= scrollableElement.scrollHeight - 1;
      if (!(draggingDown ? atTop : atBottom)) return;
    }
    event.preventDefault();
  };
  document.addEventListener('touchstart', rememberTouchStart, { passive: true });
  document.addEventListener('touchmove', cartTouchMoveBlocker, { passive: false });
}

function unlockBackgroundTouchScroll() {
  if (!cartTouchMoveBlocker) return;
  document.removeEventListener('touchstart', rememberTouchStart);
  document.removeEventListener('touchmove', cartTouchMoveBlocker);
  cartTouchMoveBlocker = null;
}

function recoverDrawerAfterFailedPatch(itemCount) {
  setTimeout(() => {
    fetch(`${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`, { cache: 'no-store' })
      .then((response) => response.text())
      .then((responseText) => {
        const ok = patchDrawerDynamicContent(responseText, itemCount);
        if (!ok) window.location.reload();
      })
      .catch(() => window.location.reload());
  }, 400);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    const innerPanelForOpen = this.querySelector('.drawer__inner');
    const onOpenTransitionEnd = (event) => {
      if (event.target !== innerPanelForOpen) return;
      this.removeEventListener('transitionend', onOpenTransitionEnd);
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    };
    this.addEventListener('transitionend', onOpenTransitionEnd);

    lockBackgroundTouchScroll(this.querySelector('cart-drawer-items'));
    document.body.classList.add('overflow-hidden', 'cart-drawer-touch-lock');

    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');

    const cartIcon = this.activeElement;

    let cleanedUp = false;
    const cleanup = () => {
      if (cleanedUp) return;
      cleanedUp = true;

      removeTrapFocus(cartIcon);
      document.body.classList.remove('overflow-hidden', 'cart-drawer-touch-lock');
      unlockBackgroundTouchScroll();
    };

    const innerPanel = this.querySelector('.drawer__inner');
    const onTransitionEnd = (event) => {
      if (event.target !== innerPanel) return;
      this.removeEventListener('transitionend', onTransitionEnd);
      cleanup();
    };
    this.addEventListener('transitionend', onTransitionEnd);
    setTimeout(cleanup, 700);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.querySelector('cart-drawer-items')?.classList.remove('is-empty');
    this.productId = parsedState.id;
    const ok = patchDrawerDynamicContent(parsedState.sections['cart-drawer'], parsedState.item_count);
    if (!ok) recoverDrawerAfterFailedPatch(parsedState.item_count);
    patchCartIconBubble(parsedState.sections['cart-icon-bubble']);

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [{ id: 'cart-drawer' }, { id: 'cart-icon-bubble' }];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const container = document.getElementById('CartDrawer');
    const candidates = [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__cart-items-wrapper' },
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.cart-drawer__subtotal-row' },
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.cart-drawer__discounts-amount' },
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.totals__total-value' },
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.cart-drawer__header-badge' },
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.cart-drawer__header-subtitle' },
    ].filter((entry) => container && container.querySelector(entry.selector));
    candidates.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return candidates;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

const CART_RESERVATION_STORAGE_KEY = 'cartDrawerReservationStart';

class CartDrawerReservationTimer extends HTMLElement {
  connectedCallback() {
    this.valueElement = this.querySelector('.cart-drawer__reservation-timer-value');
    if (!this.valueElement) return;

    const minutes = parseInt(this.dataset.minutes, 10) || 10;
    this.totalMs = minutes * 60 * 1000;

    let start = parseInt(localStorage.getItem(CART_RESERVATION_STORAGE_KEY), 10);
    if (!start || Number.isNaN(start)) {
      start = Date.now();
      localStorage.setItem(CART_RESERVATION_STORAGE_KEY, String(start));
    }
    this.startTime = start;

    this.render();
    this.intervalId = setInterval(() => this.render(), 1000);

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.cartData?.item_count === 0) {
        localStorage.removeItem(CART_RESERVATION_STORAGE_KEY);
      }
    });
  }

  disconnectedCallback() {
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  render() {
    const remainingMs = Math.max(0, this.totalMs - (Date.now() - this.startTime));
    const totalSeconds = Math.floor(remainingMs / 1000);
    const minutesPart = Math.floor(totalSeconds / 60);
    const secondsPart = totalSeconds % 60;
    this.valueElement.textContent = `${String(minutesPart).padStart(2, '0')}:${String(secondsPart).padStart(2, '0')}`;

    if (remainingMs <= 0 && this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

customElements.define('cart-drawer-reservation-timer', CartDrawerReservationTimer);

function syncPackDealGifts(cartData) {
  const items = cartData?.items;
  if (!items) return;

  const isGift = (item) => item.properties && item.properties._pack_deal_gift;
  const updates = {};
  items
    .filter((item) => item.original_price === 0 && !isGift(item))
    .forEach((item) => {
      updates[item.key] = 0;
    });
  items.filter(isGift).forEach((gift) => {
    const unitsPerGift = Number(gift.properties._pack_deal_gift_min) || 1;
    const packProducts = String(gift.properties._pack_deal_gift_products || '').split(',');
    const packUnits = items
      .filter((item) => !isGift(item) && packProducts.includes(String(item.product_id)))
      .reduce((sum, item) => sum + item.quantity, 0);
    const allowed = Math.floor(packUnits / unitsPerGift);
    if (gift.quantity > allowed) updates[gift.key] = allowed;
  });
  if (Object.keys(updates).length === 0) return;

  const drawer = document.querySelector('cart-drawer');
  fetch(`${routes.cart_update_url}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      updates,
      sections: drawer ? ['cart-drawer', 'cart-icon-bubble'] : [],
      sections_url: window.location.pathname,
    }),
  })
    .then((response) => response.json())
    .then((cart) => {
      if (!drawer || !cart.sections) {
        window.location.reload();
        return;
      }
      const isEmpty = cart.item_count === 0;
      drawer.classList.toggle('is-empty', isEmpty);
      drawer.querySelector('cart-drawer-items')?.classList.toggle('is-empty', isEmpty);
      const ok = patchDrawerDynamicContent(cart.sections['cart-drawer'], cart.item_count);
      if (!ok) recoverDrawerAfterFailedPatch(cart.item_count);
      patchCartIconBubble(cart.sections['cart-icon-bubble']);
    })
    .catch((error) => console.error(error));
}

if (typeof subscribe === 'function') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source === 'cart-items') syncPackDealGifts(event.cartData);
  });
}

if (document.querySelector('[data-pack-deal-orphan-gift]')) {
  fetch(`${routes.cart_url}.js`)
    .then((response) => response.json())
    .then(syncPackDealGifts)
    .catch((error) => console.error(error));
}
